import type { FaceScope } from '@/lib/api/grower-faces-api'

/**
 * Đích điều hướng cho các màn khuôn mặt, dạng `to` + `params` của TanStack
 * Router.
 *
 * KHÔNG dùng chuỗi nội suy (`to={`/agriculture/growers/${id}/faces`}`): router
 * khớp `to` với MẪU route trong cây, nên một đường dẫn đã thay tham số sẵn
 * không khớp cái nào và bấm vào không đi đâu cả — không lỗi, không log. Cả
 * codebase cũng theo đúng quy ước `to` mẫu + `params`.
 */
export type FaceLink = {
    to: string
    params: Record<string, string>
}

/** Chi tiết hộ — nơi có nút mở màn cấu hình khuôn mặt. */
export function growerDetailLink(growerId: string, scope: FaceScope): FaceLink {
    return scope === 'my'
        ? {
              to: '/agriculture/my-grower/$growerId',
              params: { growerId },
          }
        : { to: '/agriculture/growers/$id', params: { id: growerId } }
}

/** Danh sách khuôn mặt của một hộ. */
export function faceListLink(growerId: string, scope: FaceScope): FaceLink {
    return scope === 'my'
        ? {
              to: '/agriculture/my-grower/$growerId/faces',
              params: { growerId },
          }
        : { to: '/agriculture/growers/$id/faces', params: { id: growerId } }
}

/**
 * Màn thêm/sửa một khuôn mặt. faceId bỏ trống = thêm mới ("new"), dùng chung
 * một route vì form giống hệt nhau.
 */
export function faceEditLink(
    growerId: string,
    scope: FaceScope,
    faceId?: string,
): FaceLink {
    const id = faceId ?? 'new'
    return scope === 'my'
        ? {
              to: '/agriculture/my-grower/$growerId/faces/$faceId',
              params: { growerId, faceId: id },
          }
        : {
              to: '/agriculture/growers/$id/faces/$faceId',
              params: { id: growerId, faceId: id },
          }
}
